<ul nz-menu nzTheme="dark" nzMode="inline">
  <wx-project-device-tree authorize="ProjectList.View"></wx-project-device-tree>
  <ng-container *ngFor="let item of items$ | async">
    <ng-container *ngTemplateOutlet="menuItem; context:{data:item,paths:[item.path]}">
    </ng-container>
  </ng-container>
  <ng-template #menuItem let-data="data" let-paths="paths">
    <ng-container *ngIf="hasItems(data)">
      <li nz-submenu [nzTitle]="data.name | translate" [nzIcon]="data.icon">
        <ul>
          <ng-container *ngFor="let item of data.items">
            <ng-container *ngTemplateOutlet="menuItem; context:{data:item,paths:combinePaths(paths,item.path)}">
            </ng-container>
          </ng-container>
        </ul>
      </li>
    </ng-container>
    <ng-container *ngIf="!hasItems(data)">
      <li nz-menu-item (click)="navigate(paths)">
        <span title>
          <i nz-icon [nzType]="data.icon" nzTheme="outline"></i>
          <span class="first-level-title">{{data.name | translate}}</span>
        </span>
      </li>
    </ng-container>
  </ng-template>
</ul>